import React, {Component} from 'react';
import Button from "@material-ui/core/es/Button/Button";
import DialogActions from "@material-ui/core/es/DialogActions";
import Dialog from "@material-ui/core/es/Dialog";
import DialogContent from "@material-ui/core/es/DialogContent";
import DialogContentText from "@material-ui/core/es/DialogContentText";
import {connect} from "react-redux";
import {closeConfirmationModal} from "./ConfirmationModalActions";
import Checkbox from "@material-ui/core/es/Checkbox";
import FormControlLabel from "@material-ui/core/es/FormControlLabel";
import FormHelperText from "@material-ui/core/es/FormHelperText";
import FormControl from "@material-ui/core/es/FormControl";
import FormLabel from "@material-ui/core/es/FormLabel";
import DialogTitle from "@material-ui/core/es/DialogTitle";

class ConfirmationModal extends Component {

    state = {
        checked: false,
    };

    confirm = () => {
        const {confirmationModal: {callback, confirmCheckbox}, closeConfirmationModal} = this.props;
        const {checked} = this.state;
        if (confirmCheckbox && !checked) {
            return this.setState({error: 'Please check `Yes` to confirm'})
        }
        callback();
        closeConfirmationModal();
    };

    handleChange = () => {
        const {checked} = this.state;
        this.setState({
            checked: !checked,
            error: checked ? 'Please check `Yes` to confirm' : ''
        });
    };

    render() {
        const {brand, closeConfirmationModal, confirmationModal: {text, btn1, btn2, confirmCheckbox = true, open}} = this.props;
        const {checked, error} = this.state;
        return (
            <Dialog
                open={open}
                onClose={closeConfirmationModal}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle>
                    {text}
                </DialogTitle>
                {confirmCheckbox ? <DialogContent>
                    <DialogContentText>
                        Please confirm the following:
                    </DialogContentText>
                    <FormControl error={!!error}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checked}
                                    onChange={this.handleChange}
                                    value="checked"
                                />
                            }
                            label={`Yes, I want to permanently delete my account and all my information from ${brand.name}`}
                        />
                        {error && <FormHelperText>{error}</FormHelperText>}
                    </FormControl>
                </DialogContent>
                : <div/>}
                <DialogActions>
                    <Button onClick={closeConfirmationModal} color="primary">
                        {btn1 || 'Cancel'}
                    </Button>
                    <Button onClick={this.confirm.bind(this)} color="primary">
                        {btn2 || 'Delete My Account'}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = ({confirmationModal, brand}) => ({confirmationModal, brand});

export default connect(mapStateToProps, {closeConfirmationModal})(ConfirmationModal);



// WEBPACK FOOTER //
// ./src/components/confirmation-modal/ConfirmationModal.js